import React, { useState, useEffect, } from 'react'
import { DropdownButton, InputGroup, Button, Dropdown } from 'react-bootstrap'
import QuickSelection from '../RangeSelector/QuickSelection'
import moment from 'momentExt'
import { getQuickRanges } from 'utils'
import { dateTypeTitles } from 'modules/constants'
import {
  clampInventoryPickerRange,
  filterInventoryQuickRanges,
  inventoryEarliestSelectableDate,
} from './inventoryRetain'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DateRange } from 'react-date-range'


export default class DatePicker extends React.Component {
  render() {
    const dateFilterComponentProps = {...this.props}
    return (
      <DatePickerComponent {...dateFilterComponentProps} />
    )
  }
}

const DatePickerComponent = ({
  disabled,
  activeDateFilters,
  selectedType,
  dateFilters,
  deactivateDateType,
  changeDateType,
  dateRange,
  setDateRange,
  inventoryRetainLimit,
}) => {
  const loadQuickRanges = () => {
    const ranges = getQuickRanges()
    return inventoryRetainLimit ? filterInventoryQuickRanges(ranges) : ranges
  }
  const [quickDateRanges, setQuickDateRanges] = useState(loadQuickRanges)
  const [today, setToday] = useState(new Date())
  const [editingStart, setEditingStart] = useState(false)
  const [editingEnd, setEditingEnd] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [dates, setDates] = useState([{
    startDate: dateRange?.start ? new Date(dateRange?.start) : new Date(),
    endDate: dateRange?.end ? new Date(dateRange.end) : new Date(),
    key: 'selection',
  }])
  const [startDate, setStartDate] = useState(null)
  const dateType = selectedType

  useEffect(() => {
    if (dateRange?.start && dateRange?.end) {
      setDates([{
        startDate: new Date(dateRange.start),
        endDate: new Date(dateRange.end),
        key: 'selection',
      }])
    }
  }, [dateRange])

  const handleSetDates = (dates) => {
    setDates([dates.selection])
    if (startDate === null) {
      setStartDate(dates.selection.startDate)
    } else {
      setStartDate(null)
      onSelect({
        start: dates.selection.startDate,
        end: dates.selection.endDate,
      })
      setTimeout(async () => {
        await hideDropdown()
      }, 1000) // overlap DropdownButton onToggle event firing
    }
  }

  const onSelect = async nextDateRange => {
    const rawStart = moment(nextDateRange.start).format('YYYY-MM-DD')
    const rawEnd = moment(nextDateRange.end).format('YYYY-MM-DD')
    const clamped = inventoryRetainLimit
      ? clampInventoryPickerRange(rawStart, rawEnd)
      : { start: rawStart, end: rawEnd }
    await setDateRange({
      dateRange: clamped,
      dateType: dateType
    })
  }

  const updateDates = (start, end) => {
    if (dateRange.start._i !== start || dateRange.end._i !== end) {
      if (!isNaN((new Date(start)).getDate()) && !isNaN((new Date(end)).getDate())) {
        const momentToday = moment(today)
        const nextStartDate = moment(start, 'YYYY-MM-DD')
        let nextEndDate = moment(end, 'YYYY-MM-DD')
        if (nextStartDate.isValid()
          && nextEndDate.isValid()
          && !nextStartDate.isAfter(momentToday)
          && !nextEndDate.isAfter(momentToday)
        ) {
          nextEndDate = nextStartDate.isAfter(nextEndDate) ? nextStartDate : nextEndDate
          onSelect({ start: nextStartDate, end: nextEndDate })
        }
      }
    }
    setEditingStart(false)
    setEditingEnd(false)
  }

  const updateStartDate = e => {
    if (dateRange.start._i !== e.target.value) {
      const inputVal = e.target.value
      if (!isNaN((new Date(inputVal)).getDate())) {
        const momentToday = moment(today)
        const nextStartDate = moment(inputVal, 'YYYY-MM-DD')
        if (nextStartDate.isValid() && !nextStartDate.isAfter(momentToday)) {
          const nextEndDate = nextStartDate.isAfter(dateRange.end) ? moment(inputVal, 'YYYY-MM-DD') : dateRange.end
          onSelect({ start: nextStartDate, end: nextEndDate })
        }
      }
    }
    setEditingStart(false)
    setEditingEnd(false)
  }

  const updateEndDate = e => {
    if (dateRange.end._i !== e.target.value) {
      const inputVal = e.target.value
      if (!isNaN((new Date(inputVal)).getDate())) {
        const momentToday = moment(today)
        const nextEndDate = moment(inputVal, 'YYYY-MM-DD')
        if (nextEndDate.isValid() && !momentToday.isBefore(nextEndDate)) {
          const nextStartDate = nextEndDate.isAfter(dateRange.start) ? dateRange.start : moment(inputVal, 'YYYY-MM-DD')
          onSelect({ start: nextStartDate, end: nextEndDate })
        }
      }
    }
    setEditingStart(false)
    setEditingEnd(false)
  }

  const showDropdown = () => {
    document.getElementById(`${dateType}-range-selector-dropdown`).setAttribute('aria-expanded', true)
    document.getElementById(`${dateType}-range-selector-dropdown`).classList.add('show')
    setTimeout(() => {
      document.querySelector(`[aria-labelledby="${dateType}-range-selector-dropdown"]`).classList.add('show')
      setDropdownOpen(true)
    }, 1) // overlap DropdownButton onToggle event firing
  }

  const hideDropdown = () => {
    document.getElementById(`${dateType}-range-selector-dropdown`).setAttribute('aria-expanded', false)
    document.getElementById(`${dateType}-range-selector-dropdown`).classList.remove('show')
    document.querySelector(`[aria-labelledby="${dateType}-range-selector-dropdown"]`).classList.remove('show')
    setDropdownOpen(false)
  }

  const fromLabel = dateRange?.start ? moment(dateRange.start).format('MMM D YYYY') : ''
  const toLabel = dateRange?.end ? moment(dateRange.end).format('MMM D YYYY') : ''

  const minDate = inventoryRetainLimit
    ? inventoryEarliestSelectableDate().toDate()
    : new Date(2018, 0, 1)
  const maxDate = new Date()

  const dropdownTitle = (
    <span className="flex-1 text-input-box" style={{marginRight: 8}}>
      {
        editingStart ? (
          <input
            style={{ maxWidth: 90, color: '#000', borderRadius: 2, }}
            className={`${dateType}-start-date-input`}
            onBlur={e => {
              e.stopPropagation()
              if (editingStart && editingEnd) {
                updateDates(e.target.value, document.getElementsByClassName(`${dateType}-end-date-input`)[0].value)
              } else {
                if (e.relatedTarget?.id === `${dateType}-range-selector-dropdown`
                  || e.relatedTarget?.className === 'date-input') return
                updateStartDate(e)
              }
            }}
            onKeyDown={e => {
              e.stopPropagation()
              if (e.key === 'Enter') {
                if (editingStart && editingEnd) {
                  updateDates(e.target.value, document.getElementsByClassName(`${dateType}-end-date-input`)[0].value)
                }
                else updateStartDate(e)
              }
              else if (e.key === 'Escape') setEditingStart(false)
            }}
            defaultValue={dateRange.start.format('YYYY-MM-DD')}
            placeholder="YYYY-MM-DD"
            autoFocus
          />
        ) : (
          <span
            className="cursor-pointer underline"
            onClick={e => {
              e.stopPropagation()
              if (disabled) return
              setEditingStart(true)
            }}
          >
            {fromLabel}
          </span>
        )
      }

      <b style={{color: 'white', borderRadius: 0}}>{" To "}</b>

      {
        editingEnd ? (
          <input
            style={{ maxWidth: 90, color: '#000', borderRadius: 2, }}
            className={`${dateType}-end-date-input`}
            onBlur={e => {
              e.stopPropagation()
              if (editingStart && editingEnd) {
                updateDates(document.getElementsByClassName(`${dateType}-start-date-input`)[0].value, e.target.value)
              } else {
                if (e.relatedTarget?.id === `${dateType}-range-selector-dropdown`
                  || e.relatedTarget?.className === 'date-input') return
                updateEndDate(e)
              }
            }}
            onKeyDown={e => {
              e.stopPropagation()
              if (e.key === 'Enter') {
                if (editingStart && editingEnd) {
                  updateDates(document.getElementsByClassName(`${dateType}-start-date-input`)[0].value, e.target.value)
                }
                else updateEndDate(e)
              }
              else if (e.key === 'Escape') setEditingEnd(false)
            }}
            defaultValue={dateRange.end.format('YYYY-MM-DD')}
            placeholder="YYYY-MM-DD"
            autoFocus
          />
        ) : (
          <span
            className="cursor-pointer underline"
            onClick={e => {
              e.stopPropagation()
              if (disabled) return
              setEditingEnd(true)
            }}
          >
            {toLabel}
          </span>
        )
      }
    </span>
  )

  return (
    <span
      className={`v-center root-component range-filter-${dateType}`}
      style={{ marginRight: 0, float: 'left', textAlign: 'right', position: 'relative' }}
    >
      <InputGroup className="full-width flex-box">
        <Button id="date-type-menu" disabled={true}>
          <b style={{ color: 'white' }} className="primary-text">
            <span style={{ color: 'white' }} className="fa fa-calendar" />
          </b>
        </Button>

        <DropdownButton
          title={dropdownTitle}
          id={`${dateType}-range-selector-dropdown`}
          disabled={disabled}
          show={dropdownOpen}
          // pullright
          className="flex-box v-center"
          onToggle={() => {
            if (!dropdownOpen) {
              showDropdown()
              setToday(today)
              setQuickDateRanges(loadQuickRanges())
            } else {
              setTimeout(() => hideDropdown(), 1) // overlap DropdownButton onToggle event firing
            }
          }}
        >
          <div style={{ marginTop: -4, display: 'flex', justifyContent: 'center' }}>
            <DateRange
              onChange={handleSetDates}
              moveRangeOnFirstSelection={false}
              ranges={dates}
              minDate={minDate}
              maxDate={maxDate}
            />
          </div>
          <QuickSelection
            quickDateRanges={quickDateRanges}
            value={dateRange}
            onSelect={(e) => {
              onSelect(e)
              hideDropdown()
            }}
          />
        </DropdownButton>
        {activeDateFilters > 1 && (
          <Button
            onClick={async () => {
              await deactivateDateType(selectedType)
            }}
          >
            <span style={{ color: 'white' }} className={`fa fa-trash cursor-pointer`} />
          </Button>
        )}
      </InputGroup>
    </span>
  )
}
